import React from 'react';
import { createContext, useContext, useState, type ReactNode } from 'react';

interface ModalProviderProps {
  children: ReactNode;
}

const ModalContext = createContext<{
  modals: ReactNode[];
  setModal: (func: (prev: ReactNode[]) => ReactNode[]) => void;
}>({
  modals: [],
  setModal: () => {},
});

export const useModal = () => useContext(ModalContext);

export function ModalProvider({ children }: ModalProviderProps) {
  const [modals, setModals] = useState<ReactNode[]>([]);

  const setModal = (func: (prev: ReactNode[]) => ReactNode[]) => {
    setModals(func);
  };

  return (
    <ModalContext.Provider value={{ modals, setModal }}>
      {children}
      {modals.map((modal, index) => (
        <React.Fragment key={index}>{modal}</React.Fragment>
      ))}
    </ModalContext.Provider>
  );
}
